import { useState, useEffect, useCallback } from 'react';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';

const { COUNT_DOWN_END_TIME } = LOCAL_STORAGE_KEYS;

const calculateRemainingTime = (savedEndTime) => Math.max(0, Math.ceil((Number(savedEndTime) - Date.now()) / 1000));

const clearStoredTimer = () => localStorage.removeItem(COUNT_DOWN_END_TIME);

const getInitialCount = (isCodeSent, initialDurationInSecond) => {
  const savedEndTime = localStorage.getItem(COUNT_DOWN_END_TIME);

  if (savedEndTime) {
    const remainingTime = calculateRemainingTime(savedEndTime);
    return remainingTime;
  }

  return isCodeSent ? 0 : initialDurationInSecond;
};

const useResendTimer = (isCodeSent, initialDurationInSecond = 60) => {
  const [count, setCount] = useState(() => getInitialCount(isCodeSent, initialDurationInSecond));
  const isTimerActive = isCodeSent && count > 0;

  useEffect(() => {
    if (!isTimerActive) return undefined;

    const interval = setInterval(() => {
      const remainingTime = calculateRemainingTime(localStorage.getItem(COUNT_DOWN_END_TIME));
      if (remainingTime === 0) clearStoredTimer();
      setCount(remainingTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [isTimerActive]);

  const resetTimer = useCallback(() => {
    const endTime = Date.now() + initialDurationInSecond * 1000;
    localStorage.setItem(COUNT_DOWN_END_TIME, String(endTime));
    setCount(initialDurationInSecond);
  }, [initialDurationInSecond]);

  const clearTimer = useCallback(() => {
    clearStoredTimer();
    setCount(0);
  }, []);

  return { count, resetTimer, clearTimer };
};

export default useResendTimer;
